import { SysMetaState } from './interface';

export const getSystemtabellerMetaData = (state: SysMetaState) =>
  state.systemtableMetaData;

export const getSelectedMetaDataTable = (state: SysMetaState) =>
  state.valgtSystemTableMeta;

export const getSysMetaStatus = (state: SysMetaState) => state.status;
